import Image from "next/image";
import styles from './Footer.module.css';
import { NavLink } from '../../ui';
import { IPageMenu } from "../../../interfaces";
import Address from "./Address";
import Menu from "./Menu";
import React from "react";
import { getYear } from "@/lib/helpers/common";

type props = {
    FooterData: IPageMenu[]
}
export default function FooterAE({ FooterData }: props) {
    return (
        <footer className={styles.footer}>
            <div className="container1350">
                <div className={styles.assurance}>
                    <ul>
                        <li><figure><Image
                            width={68}
                            height={49}
                            src="/assets/images/lowest-prices-guranted.svg"
                            alt="Lowest Price"
                            className="img-responsive"
                        /></figure><div><label>Lowest Price Guaranteed</label><span>No false claims. You get what you see. Lowest Price Guaranteed on home interiors.</span></div></li>
                        <li><figure><Image
                            width={49}
                            height={46}
                            src="/assets/images/delivery-assurance.svg"
                            alt="Delivery Assurance"
                            className="img-responsive"
                        /></figure><div><label>Timely Delivery Assurance</label><span>Promised Timeline = Actual Date of Delivery. We strictly follow the timelines promised to you</span></div></li>
                    </ul>
                </div>
                <div className={styles.otherResouresBx}>
                    <div className={styles.otherResoures}>
                        <figure>
                            <Image
                                width={110}
                                height={48}
                                src="/assets/images/interior-logo-white.svg"
                                alt="Interior Company"
                                className="img-responsive"
                            />
                        </figure>
                        <Menu FooterData={FooterData && FooterData.slice(0, 4)} />
                    </div>
                </div>
                <div className={styles.otherResouresBx}>
                    <div className={styles.otherResoures}>
                        <Address />
                        <div className={styles.linkBoxes}>
                            <div className={styles.heading}>Social Links</div>
                            <ul className={styles.keppInTouch}>
                                <li><NavLink href="https://www.instagram.com/interiorcompanyofficial/" target="_blank"><Image
                                    width={20}
                                    height={20}
                                    src="/assets/images/instagram.svg"
                                    alt="instagram"
                                    className="img-responsive"
                                /></NavLink></li>
                                <li><NavLink href="https://www.facebook.com/InteriorCompanyOfficial" target="_blank"><Image
                                    width={20}
                                    height={20}
                                    src="/assets/images/facebook.svg"
                                    alt="facebook"
                                    className="img-responsive"
                                /></NavLink></li>
                                <li><NavLink href="https://www.linkedin.com/company/interiorcompanyofficial/?viewAsMember=true" target="_blank"><Image
                                    width={20}
                                    height={20}
                                    src="/assets/images/linkedin.svg"
                                    alt="linkedin"
                                    className="img-responsive"
                                /></NavLink></li>
                                <li><NavLink href="https://in.pinterest.com/interiorcompanyofficial/" target="_blank"><Image
                                    width={20}
                                    height={20}
                                    src="/assets/images/pinterest.svg"
                                    alt="pinterest"
                                    className="img-responsive"
                                /></NavLink></li>
                                <li><NavLink href="https://www.youtube.com/@InteriorCompanyOfficial" target="_blank"><Image
                                    width={25}
                                    height={25}
                                    src="/assets/images/youtube-icon-footer.svg"
                                    alt="pinterest"
                                    className="img-responsive"
                                /></NavLink></li>
                            </ul>
                        </div>
                        <div className={styles.appSplymainBox}>
                            <div className={styles.heading}>Download our app now</div>
                            <div className={styles.inFlowelinkimgm}>
                                <div className={styles.incoFolowimglet}>
                                    <Image width={145} height={51} className={`img-responsive ${styles.storeImg}`} src="/assets/images/app-store-img.png" alt="pp-store-img.png" />
                                    <Image width={145} height={144} className={`img-responsive ${styles.barCodeimg}`} src={process.env.CDN_URL + "/web/static/inco-appstore-barcode.png"} alt="inco-appstore-barcode" />
                                    <span>App Store</span>
                                </div>
                                <div className={styles.incoFoterloimgrgt}>
                                    <Image width={145} height={47} className={`img-responsive ${styles.storeImg}`} src="/assets/images/play-store-img.png" alt="play-store-img.png" />
                                    <Image width={145} height={144} className={`img-responsive ${styles.barCodeimg}`} src={process.env.CDN_URL + "/web/static/inco-playstore-barcode.png"} alt="inco-playstore-barcode" />
                                    <span>Play Store</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.copyrightSectn}>
                    <div className={styles.cpyrightDtl}>&#169; {getYear()} www.interiorcompany.com. All rights reserved</div>
                </div>
            </div>
        </footer>
    );
}